// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__H2mUv","header":"ClearentDisclaimer_header__14gHy","inner":"ClearentDisclaimer_inner__3FXTg"};